import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { jsonClient } from '../lib/api';

function TeamOverlay() {
  return {
    content: '',
    activeIndex: false,
    state: 'closed',
    first: false,
    last: false,
    image: '',
    bio: '',

    updateModal({ detail }) {
      if (window.teamModalOpen === true) {
        return;
      }
      window.teamModalOpen = true;

      disableBodyScroll(this.$el);
      this.first = detail.index === 0;
      this.last = detail.index === window.teamMembers.length - 1;

      this.fetchData(detail.fetchUrl).then((data) => {
        // eslint-disable-next-line no-console
        console.log({ data });

        this.bio = data.bio;
        this.image = data.image;

        this.state = 'open';
        this.activeIndex = detail.index;
      });
    },

    fetchData(url) {
      this.state = 'loading';
      return jsonClient(url).catch((error) => {
        this.state = 'error';

        // eslint-disable-next-line no-console
        console.error(error);
      });
    },

    closeOverlay() {
      window.teamModalOpen = false;
      this.state = 'closed';
      this.content = '';
      this.activeIndex = false;
      enableBodyScroll(this.$el);
    },

    next($dispatch) {
      const nextIndex = Math.min(
        this.activeIndex + 1,
        window.teamMembers.length - 1
      );
      const nextUrl = window.teamMembers[nextIndex];

      if (nextIndex !== this.activeIndex) {
        this.last = false;
        $dispatch('activate-item', { index: nextIndex, fetchUrl: nextUrl });
      } else {
        this.last = true;
      }
    },

    previous($dispatch) {
      const prevIndex = Math.max(this.activeIndex - 1, 0);
      const prevUrl = window.teamMembers[prevIndex];

      if (prevIndex !== this.activeIndex) {
        this.first = false;
        $dispatch('activate-item', { index: prevIndex, fetchUrl: prevUrl });
      } else {
        this.first = true;
      }
    },
  };
}

export default TeamOverlay;
